import { render } from "./amazonec2.vue?vue&type=template&id=5409e49e&scoped=true"
import script from "./amazonec2.vue?vue&type=script&lang=js"
export * from "./amazonec2.vue?vue&type=script&lang=js"

import "./amazonec2.vue?vue&type=style&index=0&id=5409e49e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5409e49e"]])

export default __exports__